module.exports = __webpack_public_path__ + "assets/img/sabc_contact_n.webp?9fa2e95f0b62529d19e08cb91ce4e36d";